/**
 * メニュー構造の型定義
 *
 * menu テーブルの type カラムと対応:
 *   sidebar_top    : サイドバー上部メニュー (depth 0)
 *   sidebar_bottom : サイドバー下部メニュー (depth 0)
 *   tab            : sidebar_top 配下のページ内タブ (depth 1)
 *   subitem        : sidebar_bottom 配下の子項目 (depth 1)
 */

export const MENU_TYPE = {
    SIDEBAR_TOP: "sidebar_top",
    SIDEBAR_BOTTOM: "sidebar_bottom",
    TAB: "tab",
    SUBITEM: "subitem",
} as const;

export type MenuTypeValue = (typeof MENU_TYPE)[keyof typeof MENU_TYPE];

/**
 * 表示用に加工した1メニュー項目
 * - name は resolveFormula 適用済み（翻訳解決後の文字列）
 * - children は親メニューに紐付いた子項目（tab or subitem）
 */
export interface MenuItem {
    id: number;
    code: string;
    type: string;
    parentId: number | null;
    name: string;
    url: string | null;
    icon: string | null;
    displayOrder: number;
    children: MenuItem[];
}

/**
 * サイドバー全体の構成
 */
export interface SidebarMenus {
    top: MenuItem[];
    bottom: MenuItem[];
}
